module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/sKXCcP/tc-custom/9783988268587.jpg?1704453168009",
      "alt": "This image is the cover for the book Maurice and the Bay Mare & Lost Farm Camp, Classics To Go"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Maurice and the Bay Mare & Lost Farm Camp, Classics To Go\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Maurice and the Bay Mare follows the adventures of the titular character, Maurice, a rugged and skilled cowboy in the American West. The heart of the story centers around Maurice's connection with a remarkable bay mare, a spirited and highly prized horse. \"Lost Farm Camp\" is a tale that paints a vivid picture of life in the American West during a time when the frontier was still being explored and settled. It provides a glimpse into the challenges and rewards of living amidst the beauty and harsh realities of the untamed land.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Henry Herbert Knibbs\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Henry Herbert Knibbs (January 24, 1874 – February 10, 1945) was an American poet, journalist, and author known for his Western poetry and cowboy-themed works. He gained popularity during the early 20th century for his ability to capture the essence of the American West in his poetry and storytelling.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    OTB ebook\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0